import { motion } from "framer-motion";
import { forwardRef } from "react";

const Button = forwardRef(
  (
    {
      children,
      variant = "primary",
      className = "",
      disabled = false,
      loading = false,
      ...props
    },
    ref
  ) => {
    const baseClasses =
      "px-6 py-3 rounded-2xl font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2";

    const variantClasses = {
      primary:
        "bg-primary text-white hover:scale-105 hover:shadow-glow active:scale-95",
      secondary:
        "bg-transparent border-2 border-primary text-primary hover:bg-primary/10 active:scale-95",
      tertiary:
        "bg-transparent text-primary hover:bg-primary/5 active:scale-95",
      danger:
        "bg-red-500 text-white hover:bg-red-600 hover:scale-105 active:scale-95",
      success:
        "bg-green-500 text-white hover:bg-green-600 hover:scale-105 active:scale-95",
    };

    return (
      <motion.button
        ref={ref}
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        disabled={disabled || loading}
        whileHover={!disabled && !loading ? { scale: 1.02 } : {}}
        whileTap={!disabled && !loading ? { scale: 0.98 } : {}}
        {...props}
      >
        {loading && (
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        )}
        {children}
      </motion.button>
    );
  }
);

Button.displayName = "Button";

export default Button;

